namespace InvData {

    export class PropertyDefinition {

        public id: number;
        public code: string;
        public label: string;
        public allowMultiple: boolean;
        public isStaticOverTime: boolean;
        public propertyTypeId: number;
        public tagRefTagSetId: number;
        public category: string;

        constructor(propDefData) {
            this.id = propDefData.id ? propDefData.id : null;
            this.code = propDefData.code ? propDefData.code : null;
            this.label = propDefData.label ? propDefData.label : null;

            this.allowMultiple = propDefData.allowMultiple ? propDefData.allowMultiple : false;
            this.isStaticOverTime = propDefData.isStaticOverTime ? propDefData.isStaticOverTime : false;

            this.propertyTypeId = propDefData.propertyTypeId ? propDefData.propertyTypeId : null;
            this.tagRefTagSetId = propDefData.tagRefTagSetId ? propDefData.tagRefTagSetId : null;

            this.category = propDefData.category;
        }

    }

}


